/* eslint-disable react-hooks/exhaustive-deps */
import { isEmpty } from 'lodash';
import React, { useEffect, useState } from 'react';
import useForm from '../../hooks/useForm';
import systemAlert from '../../utils/systemAlert';
import Filters from '../Filters';
import { ControlTable } from '../Table';
import { deleteSeminarRecruitment, seminarCategories, seminarRecruitments } from '../../apis/admin/seminar';
import { getParams } from '../../utils/params';
import Recruitment from './Recruitment';
import { dateToFormat } from '../../utils/date';

const Recruitments = () => {
  const [detailOpen, setDetailOpen] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const [categories, setCategories] = useState([]);
  const [fields] = useState([
    { title: "제목", key: "title" },
    { title: "장소", key: "place" },
    { title: "등록일", key: "createdTime", type: "datetime" },
    {
      title: "모집일시", key: "reruitmentStartTime",
      onValue: (_v, _f, data) => {
        return `${dateToFormat(data.reruitmentStartTime, 'YY.MM.DD HH:mm')} ~ ${dateToFormat(data.reruitmentEndTime, 'YY.MM.DD HH:mm')}`;
      }
    },
    {
      title: "모임일시", key: "seminarStartTime",
      onValue: (_v, _f, data) => {
        return `${dateToFormat(data.seminarStartTime, 'YY.MM.DD HH:mm')} ~ ${dateToFormat(data.seminarEndTime, 'YY.MM.DD HH:mm')}`;
      }
    },
    {
      type: "button",
      size: "x-sm",
      color: "gray-line",
      label: "수정",
      onClick: ({ data }) => {
        setDetailOpen(true);
        setSelectedItem(data);
      },
    },

  ]);

  const [filters, setFilters] = useState([
    {
      title: "제목",
      key: "search.title",
      options: {
        placeholder: "제목입력",
      },
    },
    {
      title: "강연자",
      key: "search.lecturer",
      options: {
        placeholder: "강연자 입력",
      },
    },
  ]);

  const {
    form,
    setSubmit,
    handleOnChange,
    // handleSubmit,
    // LIST 용
    filterSubmit,
    list, setList,
    selectedList, setSelectedList,
    isLoading, setIsLoading,
    total, setTotal,
    page, setPage,
    limit, setLimit,
    reSubmit
  } = useForm({
    order: [
      {
        idx: "desc"
      },
    ],
    page: 0,
    limit: 10,
    hideView: true,
  },);

  const [tableButtons, setTableButtons] = useState();

  const submit = (param) => {
    if (param?.search?.categories === "0") delete param.search.categories;
    seminarRecruitments(getParams({
      ...param,
      search: {
        ...(param.search || {}),
        ...(!isEmpty(param?.search?.categories) && +param?.search?.categories > 0 ?
          { categories: [+param?.search?.categories] }
          : {})
      }
    }))
      .then(res => {
        const { rows, count } = res.seminarRecruitments;
        setTotal(count);
        setList(rows);
      }).finally(() => {
        setIsLoading(false);
      });
  };

  const getCategoires = () => {
    seminarCategories().then(res => {
      const { rows } = res;
      setCategories(rows);
    });
  };

  useEffect(() => {
    submit(form);
    setSubmit(submit);
    getCategoires();
  }, []);

  useEffect(() => {
    setFilters([
      {
        title: "제목",
        key: "search.title",
        options: {
          placeholder: "제목입력",
        },
      },
      {
        title: "강연자",
        key: "search.lecturer",
        options: {
          placeholder: "강연자 입력",
        },
      },
      {
        title: "카테고리",
        key: "search.categories",
        type: "select",
        options: {
          list: [
            { label: "전체", value: "0" },
            ...categories.map(item => ({ label: item.name, value: item.idx + "" }))
          ]
        },
      },
    ]);
  }, [categories]);

  useEffect(() => {
    setTableButtons([
      {
        label: "일괄삭제",
        color: "red",
        disabled: isEmpty(selectedList),
        action: () => {
          if (selectedList.length > 0) {
            systemAlert(`"${selectedList[0].title}" ${selectedList.length - 1 > 0 ? ` 외 ${selectedList.length - 1}개` : ""}을(를) 삭제하시겠습니까?`, {
              buttons: [
                {
                  color: 'text',
                  label: '취소'
                },
                {
                  label: '삭제',
                  color: 'red',
                  onClick: () => {
                    deleteSeminarRecruitment({ idx: selectedList.map(item => item.idx) })
                      .then(res => {
                        submit && submit(form);
                        setSelectedList([]);
                      }).catch(err => {
                        console.error(err.response);
                      }).finally(() => {
                        setIsLoading(false);
                      });
                  }
                }
              ]
            });
          }
        },
      },
      { label: "모집일정 등록", action: () => setDetailOpen(true) }
    ]);
  }, [selectedList]);

  return (
    <>
      <Filters
        isLoading={isLoading}
        filters={filters}
        submit={filterSubmit}
        form={form}
        onChange={handleOnChange}
      />

      <ControlTable
        fields={fields}
        list={list}
        isLoading={isLoading}
        selectedList={selectedList}
        setSelected={setSelectedList}
        total={total}
        page={page}
        setPage={setPage}
        limit={limit}
        setLimit={setLimit}
        isControl={true}
        buttons={tableButtons}
      />

      <Recruitment
        open={detailOpen}
        setOpen={setDetailOpen}
        submit={reSubmit}
        selectedItem={selectedItem}
        setSelectedItem={setSelectedItem}
      />
    </>
  );
};

export default Recruitments;